


























import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import * as _ from "lodash";
import axios, { resHandle } from "@/plugins/axios";
@Component({})
export default class ObjectSelectSearch extends Vue {
  @Prop()
  private message: any;
  private resultOptions: any[] = [];
  @Prop()
  private type: any;
  @Prop()
  private name: any;
  @Prop()
  private pl: any;
  private loading: boolean = false;
  private get m() {
    return this.message;
  }
  private set m(val) {
    this.$emit("update:message", val);
  }
  @Watch("name")
  private nameChange(oV, nV) {
    this.fetchOptions(this.name);
  }
  /**
   * @description 搜索
   */
  private fetchOptions(ev) {
    this.loading = true;
    const params: any = {
      search: ev,
    };
    let api: any = "";
    switch (this.type) {
      case "子产品":
        api = "api/admin/search/products";
        break;
    }
    axios.post(api, params).then(({ data }) => {
      resHandle(this, data)
        .then(() => {
          this.resultOptions = data.data;
        })
        .finally(() => {
          this.loading = false;
        });
    });
  }
  /**
   * @description 默认搜索
   */
  private defaultSearch(ev) {
    this.fetchOptions(" ");
  }
  /**
   * 初始化
   */
  private mounted() {
    if (this.type === "子产品") {
      return;
    }
  }
}
